import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ImageBackground, ScrollView } from 'react-native';
import { RFValue } from "react-native-responsive-fontsize";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import Octicons from "@expo/vector-icons/Octicons";

const Placementresult = ({ navigation, route }) => {

    // تجزیه دیتای دریافتی که شامل exam و placement است
    const exam = JSON.parse(route.params.exam);

    const placement = JSON.parse(route.params.placement);



    return (
        <ScrollView contentContainerStyle={styles.container}>
            <View style={styles.header}>
                {exam.percent > 65 &&
                    <>
                        <ImageBackground
                            resizeMode="contain"
                            source={require('../../assets/images/win.png')}
                            style={styles.image}
                        />
                        <View style={styles.boxgreen}>
                            <Text style={styles.greentext}>{exam.percent}%</Text>
                        </View>
                    </>
                }
                {exam.percent > 39 && exam.percent < 65 && (
                    <View style={styles.boxyellow}>
                        <Text style={styles.yellowtext}>{exam.percent}%</Text>
                    </View>
                )}
                {exam.percent < 40 &&
                    <View style={styles.boxred}>
                        <Text style={styles.redtext}>{exam.percent}%</Text>
                    </View>
                }
            </View>

            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                {/*{exam.percent > 65 &&*/}
                {/*    <>*/}
                {/*        <Text style={styles.title}>خیلی فوق‌العاده بود!</Text>*/}
                {/*        <Text style={styles.subtitle}>همین‌جوری ادامه بده و همه رکوردها رو بشکن</Text>*/}
                {/*    </>*/}
                {/*}*/}
                {/*{exam.percent > 39 && exam.percent < 65 && (*/}
                {/*    <>*/}
                {/*        <Text style={styles.title}>یکم دیگه تلاش کن!</Text>*/}
                {/*        <Text style={styles.subtitle}>مطمئنم با تلاش بیشتر، به نتیجه عالی می‌رسی</Text>*/}
                {/*    </>*/}
                {/*)}*/}
                {/*{exam.percent < 40 &&*/}
                {/*    <>*/}
                {/*        <Text style={styles.title}>تو شکست نخوردی، داری یاد می‌گیری!</Text>*/}
                {/*        <Text style={styles.subtitle}>بلند شو، ادامه بده و دفعه بعد نتیجه بهتری بگیر</Text>*/}
                {/*    </>*/}
                {/*}*/}

                {/* باکس نمایش سطح کاربر (Placement) */}
                {placement && (
                    <View style={styles.placementBox}>
                        <Text style={styles.placementLabel}>سطح شما</Text>
                        <Text style={styles.placementLevel}>{placement.level}</Text>
                        <Text style={styles.placementTitle}>{placement.title}</Text>
                    </View>
                )}

                <View style={styles.timeContainer}>
                    <AntDesign name="clockcircleo" size={RFValue(20)} color="#FFCC3E" />
                    <Text style={styles.time}>{`  ${exam.time}`}</Text>
                </View>

                <View style={styles.resultRow}>
                    <View style={styles.boxresultgreen}>
                        <Text style={styles.gt}>{exam.truee}</Text>
                        <Text style={styles.gt}>صحیح</Text>
                    </View>
                    <View style={styles.boxresultred}>
                        <Text style={styles.rt}>{exam.falsee}</Text>
                        <Text style={styles.rt}>خطا</Text>
                    </View>
                </View>
            </View>

            {/* دکمه بازگشت به خانه */}
            <TouchableOpacity
                style={styles.secondaryButton}
                onPress={() => navigation.navigate('Home')}
            >
                <Octicons name="home" size={RFValue(20)} color={Config.maincolor} style={{marginHorizontal:'5'}} />

                <Text style={styles.buttonTextresult}>
                    {`  `}
                    بازگشت به خانه
                </Text>
            </TouchableOpacity>

            {/* دکمه تکرار و تمرین */}
            {/*<TouchableOpacity*/}
            {/*    style={styles.buttonresult}*/}
            {/*    onPress={() => {*/}
            {/*        navigation.navigate('StartPlacement');*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Text style={styles.buttonTextresult}>تکرار و تمرین</Text>*/}
            {/*    <AntDesign name="left" size={RFValue(20)} color={Config.maincolor} />*/}
            {/*</TouchableOpacity>*/}

            {/* دکمه ادامه - فقط در صورتی که course_id وجود داشته باشد نمایش داده می‌شود */}
            {exam.course_id && (
                <View style={{ marginTop: RFValue(10) }}>
                    <TouchableOpacity
                        onPress={() => {
                            navigation.navigate('Home');
                        }}
                        style={styles.button}
                    >
                        <Text style={styles.buttonText}>ادامه</Text>
                    </TouchableOpacity>
                </View>
            )}
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: '#FAFAFA',
        paddingVertical: RFValue(20),
        paddingHorizontal: RFValue(20),
    },
    header: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: RFValue(20),
        marginBottom: RFValue(10),
    },
    image: {
        width: RFValue(220),
        height: RFValue(220),
        position: 'absolute',
        top: -RFValue(40),
        zIndex: 0, // قرار دادن عکس پشت دایره
    },
    // دایره‌ها باید border radius عددی داشته باشند تا در اندروید و iOS گرد شوند
    boxgreen: {
        width: RFValue(150),
        height: RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: RFValue(75),
        borderWidth: RFValue(6),
        borderColor: '#33B300',
        backgroundColor: '#FFF',
        zIndex: 1,
    },
    greentext: {
        fontSize: RFValue(24),
        fontFamily: 'ykb',
        color: '#33B300',
    },
    boxyellow: {
        width: RFValue(150),
        height: RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: RFValue(75),
        borderWidth: RFValue(6),
        borderColor: '#F28B1C',
        backgroundColor: '#FFF',
    },
    yellowtext: {
        fontSize: RFValue(24),
        fontFamily: 'ykb',
        color: '#F28B1C',
    },
    boxred: {
        width: RFValue(150),
        height: RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: RFValue(75),
        borderWidth: RFValue(6),
        borderColor: '#D90000',
        backgroundColor: '#FFF',
    },
    redtext: { // نام اصلاح شده از rdtext به redtext
        fontSize: RFValue(24),
        fontFamily: 'ykb',
        color: '#D90000',
    },
    placementBox: {
        backgroundColor: '#F0F4FF',
        borderWidth: 1,
        borderColor: Config.maincolor || '#4A90E2',
        borderRadius: RFValue(15),
        padding: RFValue(15),
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: RFValue(20),
        width: '100%',
    },
    placementLabel: {
        fontFamily: 'yk',
        fontSize: RFValue(14),
        color: '#555',
    },
    placementLevel: {
        fontFamily: 'ykb',
        fontSize: RFValue(36),
        color: Config.maincolor || '#4A90E2',
        marginVertical: RFValue(5),
    },
    placementTitle: {
        fontFamily: 'ykb',
        fontSize: RFValue(16),
        color: '#0D1134',
    },
    timeContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: RFValue(10),
    },
    time: {
        color: "#FFCC3E",
        textAlign: "center",
        fontFamily: 'ykb',
        fontSize: RFValue(18),
    },
    title: {
        color: "#0D1134",
        textAlign: "center",
        fontFamily: 'ykb',
        fontSize: RFValue(20),
        marginTop: RFValue(10),
    },
    subtitle: {
        color: "#0D1134",
        textAlign: "center",
        fontFamily: 'yk',
        fontSize: RFValue(14),
        marginTop: RFValue(7),
    },
    resultRow: {
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        marginTop: RFValue(10),
    },
    boxresultgreen: {
        backgroundColor: '#E9FFE0',
        borderWidth: 1,
        borderRadius: RFValue(20),
        height: RFValue(100),
        width: '48%',
        justifyContent: 'center',
        alignItems: 'center',
        borderColor: '#33B300',
    },
    boxresultred: {
        backgroundColor: '#FFD5D5',
        borderWidth: 1,
        borderRadius: RFValue(20),
        borderColor: '#D90000',
        height: RFValue(100),
        width: '48%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    gt: {
        color: "#33B300",
        textAlign: "center",
        fontFamily: 'ykb',
        fontSize: RFValue(18),
        marginTop: RFValue(5),
    },
    rt: {
        color: "#D90000",
        textAlign: "center",
        fontFamily: 'ykb',
        fontSize: RFValue(18),
        marginTop: RFValue(5),
    },
    secondaryButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center', // جایگزین marginHorizontal: 'auto'
        marginTop: RFValue(25),
        borderRadius: RFValue(10),
        borderWidth: 1,
        padding: RFValue(12),
        width: '100%',
        borderColor: '#E7E9F2',
        backgroundColor: Config.secondcolor || '#FFF'
    },
    buttonresult: {
        borderColor: '#E7E9F2',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderWidth: 1,
        backgroundColor: '#FFF',
        marginTop: RFValue(15),
        padding: RFValue(15),
        borderRadius: RFValue(15),
    },
    buttonTextresult: {
        color: Config.maincolor || '#000',
        textAlign: "center",
        fontFamily: 'ykb',
        fontSize: RFValue(14),
    },
    buttonText: {
        fontFamily: 'ykb',
        fontSize: RFValue(16),
        color: '#FFF', // معمولاً متن داخل دکمه اصلی سفید است
    },
    button: {
        backgroundColor: Config.maincolor || '#4A90E2',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: RFValue(15),
        borderRadius: RFValue(30),
        height: RFValue(45),
    },
});

export default Placementresult;